<template>
  <v-layout
    class="add-new-customer"
    row
    justify-center>
    <v-dialog
      v-model="customerDialog.show"
      persistent
      scrollable
      max-width="800px"
    >
      <v-card>
        <v-card-title v-if="customerDialog.type==='new'">Create New Customer</v-card-title>
        <v-card-title v-else>Edit Customer</v-card-title>
        <v-card-text>
          <v-container>
            <v-form
              ref="customerForm"
              v-model="valid"
              lazy-validation
            >
              <v-alert
                v-model="customerDialog.showResponse"
                :dismissible="true"
                :type="customerDialog.responseType"
                class="mb-3"
              >
                {{ customerDialog.responseMessage }}
              </v-alert>
              <v-text-field
                v-validate="'required'"
                v-model="customerDialog.fields.Customer_Name"
                :error-messages="errors.collect('Customer_Name')"
                :disabled="isRecordView"
                type="text"
                data-vv-name="Customer_Name"
                data-vv-validate-on="blur"
                label="Customer Name" />
              <v-select
                v-validate="'required'"
                :items="['All Region', 'APJ-MEA','Europe','Americas','UKI']"
                :error-messages="errors.collect('Customer_Region')"
                :disabled="isRecordView"
                v-model="customerDialog.fields.Customer_Region"
                data-vv-name="Customer_Region"
                data-vv-validate-on="blur"
                label="Customer Region"
              />
              <v-text-field
                v-validate="'required|max:15'"
                v-model="customerDialog.fields.Customer_Alias"
                type="text"
                hint="Shortname must be maximum character of 15. "
                :error-messages="errors.collect('Customer_Alias')"
                :disabled="isRecordView"
                data-vv-name="Customer_Alias" 
                data-vv-validate-on="blur">
                 <template slot="label"> <span v-html="`Customer Alias <span style='color:red' class='required'>*</span>`"/></template> 
              </v-text-field>

               <v-switch
                :disabled="isRecordView"
                v-model=" customerDialog.isSingleMp"
                label="Is this customer has single master payer?"
                @change="isSingleMp()"
              ></v-switch>
               <v-autocomplete
                    v-if="customerDialog.isSingleMp"
                    :items="mPayers"

                    v-model="customerDialog.fields.Master_Id"
                    item-text="MP_Name"
                    item-value="MP_ID"
  
                   label="Choose Workload"
                      placeholder="Choose Workload"
                      attach
                   >
                    <template slot="label">
                      <span v-html="`Choose Masterpayer <span style='color:red' class='required'>*</span>`"/>
                    </template>
               </v-autocomplete>
            </v-form>
          </v-container>
        </v-card-text>
        <v-divider/>
        <v-card-actions >
          <v-spacer/>
          <div v-if="customerDialog.responseType=='success'">
            <v-btn
              @click.stop="customerDialog.show=false" >Close</v-btn>
          </div>
          <div v-else>
            <v-btn
              :loading="customerDialog.saving"
              :disabled="customerInvalid"
              color="orange"
              @click="customerDialog.submitHandler(customerDialog.fields)">{{ customerDialog.submitLabel }}</v-btn>
            <v-btn
              :disabled="customerDialog.saving"
              @click.stop="customerDialog.show=false">{{ customerDialog.cancelLabel }}</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      valid: null,
      step: 1,
      search: null
    }
  },
  computed: {
    ...mapState('admin', ['customerDialog','mPayers']),
    customerInvalid () {
      return !!(!this.customerDialog.fields.Customer_Name ||
        !this.customerDialog.fields.Customer_Region ||
        !this.customerDialog.fields.Customer_Alias ||
        this.customerDialog.type === 'view' ||
        this.errors.items.length)
    },
    isRecordView() {
      return this.customerDialog.type === 'view'
    },
  },
  watch: {

  },
  methods: {
    isSingleMp(){
      console.log('isSingleMp: ', this.customerDialog.isSingleMp)
      if(this.customerDialog.isSingleMp === false){
        this.customerDialog.fields.Master_Id = 'None'
      }
    }
  }
}
</script>
<style lang="scss">

</style>
